module.exports = __webpack_public_path__ + "img/garantie-alternative.3bce2f44.svg";